import React from "react";
import {useSelector} from "react-redux";
import {subduedTextColour} from "../../style/styleConsts";
import styled from "styled-components";
import closedIcon from "../../../images/icon-roadmap-check.svg";
import noneClosedIcon from "../../../images/icon-roadmap-cross.svg";
import notClosedIcon from "../../../images/icon-alert-circle.svg";

const TopRow = styled.div`
    display: flex;
    align-items: center
`;

const IdeaCloseStatusIcon = styled.img`
    float: left;
    height: 2.6em;
    width: 2.6em;
    vertical-align: -40%;
    margin-right: 30px;
`;

export const IdeaCloseStatusMessage = styled.div`
    font-size: 1.5em;
    font-weight: bold;
`;

const CloseOutcomeContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const OmissionsContainer = styled.div`
    display: flex;
    align-items: start;
    max-height: 530px;
    overflow-y: auto;
`;

const OmisssionMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const NotClosedIcon = styled.img`
    margin-top: 4px;
    margin-right: 32px;
    margin-left: 6px;
    height: 29px;
    width: 29px;
`;

const IdeaStillOpenText = styled.div`
    font-size: 1.2em;
    color: ${subduedTextColour};
`;

const DividingLine = styled.div`
    width: 100%;
    border-bottom: 1px solid grey;
    margin: 18px 0 8px;
`;

const PortfolioNameAndReasonContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 8px;
`;

const CloseOutcome = ({}) => {
    const closing = useSelector(state => state.ideaDetails.closing);
    const totalIntendedClose = closing.closed + closing.omissions.length;
    const showOutOf = closing.closed > 0 && closing.closed !== totalIntendedClose;

    let closeResultText;
    if (showOutOf) {
        closeResultText = `Closed for ${closing.closed} out of ${totalIntendedClose} portfolio${totalIntendedClose !== 1 ? "s" : ""}`;
    } else {
        closeResultText = `Closed for ${closing.closed} portfolio${closing.closed !== 1 ? "s" : ""}`;
    }

    if (totalIntendedClose === 0) {
        return null;
    }

    const omissionsComponent = closing.omissions.length === 0 ? null : ([
            <DividingLine key="omissions-dividing-line"/>,

            <OmissionsContainer key="omissions-container">
                <NotClosedIcon key="not-closed-icon" src={notClosedIcon}/>
                <OmisssionMessageContainer>
                    <IdeaStillOpenText>Idea is still open for...</IdeaStillOpenText>
                    {
                        closing.omissions.map(omission => (
                            <PortfolioNameAndReasonContainer key={omission.portfolio} className="t-idea-still-open">
                                <strong className="t-portfolio">{omission.portfolio}</strong>
                                {
                                    omission.reasons.map(r => <div key={r} className={"t-reason"}>{r}</div>)
                                }

                            </PortfolioNameAndReasonContainer>
                        ))
                    }
                </OmisssionMessageContainer>
            </OmissionsContainer>
        ]
    );

    return (
        <CloseOutcomeContainer className="t-close-outcome">
            <TopRow>
                <IdeaCloseStatusIcon src={closing.closed ? closedIcon : noneClosedIcon}/>
                <IdeaCloseStatusMessage className="t-ideas-closed">{closeResultText}</IdeaCloseStatusMessage>
            </TopRow>

            {omissionsComponent}
        </CloseOutcomeContainer>
    );
};

export default CloseOutcome;
